import React from 'react';
import { StyleSheet, View } from 'react-native';

export default function SidebarIcon({ color, size = 22 }) {
  const scale = size / 22;
  return (
    <View style={{ width: size, height: 20 * scale, borderWidth: 1.7 * scale, borderRadius: 4 * scale, borderColor: color }}>
      <View style={[styles.divider, { left: 6 * scale, borderLeftWidth: 1.7 * scale, borderColor: color }]} />
    </View>
  );
}

const styles = StyleSheet.create({
  divider: { position: 'absolute', top: 0, bottom: 0 },
});
